import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

class Logo extends Component {

    constructor(props) {
        super(props)

        this.state = {
            logo: {
                default: '/assets/img/logo.svg',
                alt: '/assets/img/logo--light.svg'
            }
        }
    }

    getLogo() {
        const { logo } = this.state
        const { pathname } = this.props.location

        switch (true) {
            case (pathname.indexOf('/work') > -1):
            case (pathname.indexOf('/blog') > -1):
                return logo.alt
            default:
                return logo.default
        }
    }

    render() {
        const logo = this.getLogo()
        return (
            <div className="header__logo">
                <Link to="/">
                    <img width="100" height="76" src={logo} alt="David Walker logo" />
                </Link>
            </div>
        );
    }
}

export default withRouter(Logo);



// WEBPACK FOOTER //
// ./src/components/Global/Logo.js